module.exports = __webpack_public_path__ + "img/ubi.fa6837f5.svg";